import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import toCodeIcon from './icon--tocode.png';
import styles from './stop-all.css';

const StopAllComponent = function (props) {
    const {
        active,
        className,
        onClick,
        ...componentProps
    } = props;
    return (
        <img
            className={classNames(
                className,
                styles.stopAll,
                {
                    [styles.isActive]: active
                }
            )}
            draggable={false}
            src={toCodeIcon}
            onClick={onClick}
            {...componentProps}
        />
    );
};

StopAllComponent.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

StopAllComponent.defaultProps = {
    active: false
};

export default StopAllComponent;
